import React, { useCallback } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField';
import { PrimaryLayout } from '../Layout';

function PrimaryTab(props) {
    var currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    // FormField calls onFormLoad() unconditionally in a finally block with no default and no guard
    // (FormField.js:256), so it is a required prop even when there is nothing to load. The lookups on
    // this form fetch their own data, hence the no-op.
    const handleFormLoad = useCallback(() => {
    }, []);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='2C8D6B93-4F17-4A50-B62E-9D3F5A7C1E48'
                layoutName='WMItemDataProfilePrimaryForm'
                defaultFormSchema={PrimaryLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={props.handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handleFormLoad}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(PrimaryTab);
